import { useState } from 'react'

import { ContactDrawerTab } from './useContactDrawerTabs.types'

export const useContactDrawerTabs = () => {
  const [currentTab, setCurrentTab] = useState<ContactDrawerTab>('Details')

  return { currentTab, setCurrentTab }
}
